import { useContext, useEffect, useState } from "react";
import { AppContext } from "../App";
import { getInlineLoader } from "../Helpers";
import banner5 from "../assets/bg.jpg";


export default function HomeBanner3() {
  const appContext = useContext(AppContext);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    setReady(true);
  }, []);

  if (!ready) {
    return getInlineLoader();
  }

  return (
    <div
      className="MainBodySection"
      style={{
        padding: 0,
        backgroundImage: `url(${banner5})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      <div className="container">
        <div className="row">
          {/* CTA */}
          <div className="col-md-12 my-5 text-center py-5 px-3">
	  		<div
          className="py-5 px-3"
          style={{
            background: "rgba(255,255,255,.85)"
          }}
        >
          <h1 className="main-section-title text-secondary">JENGA CONSTRUCTION LIMITED</h1>
          <h5 className="mb-5">
            Jenga Construction Ltd was officially registered with the Government of Tanzania through the Registrar of Companies and a reputable and fast-growing construction company committed to delivering high-quality building and civil engineering solutions. 
            <br/><br/>
            Established with the aim of providing reliable and sustainable services, the company has developed a strong footprint in the industry through professionalism, innovation, and consistent project delivery
          </h5>
          <button
            className="btn btn-padded btn-secondary"
            onClick={() => appContext.navTo({ item: "about_us" })}
          >
            Learn More About Us
          </button>
			  </div>
      </div>
    </div>
  </div>
</div>
  );
}
